import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { compose, branch, renderNothing } from "recompose";
import Sidebar from "../components/Sidebar";
import { Container } from "reactstrap";
import Header from "../components/Header/Header";
import TitleContextWrapper from "./TitleContextWrapper";

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
};

const EnhancedHeader = branch(({ width }) => width > 991, renderNothing)(
  Header
);

const SidebarLayout = compose(({ type, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={compose(matchProps => (
        <TitleContextWrapper>
          <div className="wrapper">
            <Sidebar {...rest} />
            <div id="main-panel" className="main-panel">
              <EnhancedHeader {...rest} />
              <div className="content main-content-dashboard">
                <Container fluid>
                  <Component {...matchProps} />
                </Container>
              </div>
            </div>
          </div>
        </TitleContextWrapper>
      ))}
    />
  );
});

SidebarLayout.propTypes = propTypes;

export default SidebarLayout;
